import type { MetricDtoTags } from './metricDtoTags';

export interface MetricDto {
  id?: number;
  name: string;
  tags?: MetricDtoTags;
  timestamp: string;
  type: string;
  userId: string;
  value: number;
}
